import { render, staticRenderFns } from "./taskListItem.vue?vue&type=template&id=8929c1a6&"
import script from "./taskListItem.vue?vue&type=script&lang=js&"
export * from "./taskListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports